import React from 'react';
import { useFormikContext, ErrorMessage } from 'formik';
import { FormControl, FormLabel, Input, Select, VStack, FormErrorMessage } from '@chakra-ui/react';

const GenericSMTP = ({ setGatewayData }) => {
  const { errors, touched, values, setFieldValue } = useFormikContext();

  const handleChange = (field, event) => {
    const value = event.target.value;
    // Update the credentials state directly
    setFieldValue(`credentials.${field}`, value);
    setGatewayData({ ...values.credentials, [field]: value });
  };

  return (
    <VStack spacing={4} alignItems="flex-start">
      <FormControl isInvalid={errors.name && touched.name}>
        <FormLabel>Name</FormLabel>
        <Input
          name={`credentials.name`} 
          placeholder="Enter your name"
          value={values.credentials.name || ''}
          onChange={(e) => handleChange('name', e)}
        />
        <ErrorMessage name={`credentials.name`} component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.host && touched.host}>
        <FormLabel>Host</FormLabel>
        <Input
          name={`credentials.host`} 
          placeholder="smtp.example.com"
          value={values.credentials.host || ''}
          onChange={(e) => handleChange('host', e)}
        />
        <ErrorMessage name={`credentials.host`} component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.port && touched.port}>
        <FormLabel>Port</FormLabel>
        <Input
          name={`credentials.port`} 
          placeholder="25"
          value={values.credentials.port || ''}
          onChange={(e) => handleChange('port', e)}
        />
        <ErrorMessage name={`credentials.port`} component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.username && touched.username}>
        <FormLabel>Username</FormLabel>
        <Input
          name={`credentials.username`}
          placeholder="your_username"
          value={values.credentials.username || ''}
          onChange={(e) => handleChange('username', e)}
        />
        <ErrorMessage name={`credentials.username`} component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.password && touched.password}>
        <FormLabel>Password</FormLabel>
        <Input
          type="password"
          name={`credentials.password`} 
          placeholder="your_password"
          value={values.credentials.password || ''}
          onChange={(e) => handleChange('password', e)}
        />
        <ErrorMessage name={`credentials.password`} component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.from && touched.from}>
        <FormLabel>From</FormLabel>
        <Input
          name={`credentials.from`} 
          placeholder="example@example.com"
          value={values.credentials.from || ''}
          onChange={(e) => handleChange('from', e)}
        />
        <ErrorMessage name={`credentials.from`} component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.replyTo && touched.replyTo}>
        <FormLabel>Reply To</FormLabel>
        <Input
          name={`credentials.replyTo`} 
          placeholder="replyto@example.com"
          value={values.credentials.replyTo || ''}
          onChange={(e) => handleChange('replyTo', e)}
        />
        <ErrorMessage name={`credentials.replyTo`} component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.security && touched.security}>
        <FormLabel>Security</FormLabel>
        <Select
          name={`credentials.security`} 
          value={values.credentials.security || ''}
          onChange={(e) => handleChange('security', e)}
        >
          <option value="">Select Security Type</option>
          <option value="SSL">SSL</option>
          <option value="TLS">TLS</option>
          <option value="None">None</option>
        </Select>
        <ErrorMessage name={`credentials.security`} component={FormErrorMessage} />
      </FormControl>
    </VStack>
  );
};

export default GenericSMTP;
